import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { computed } from 'mobx';
import { Model } from 'core/model/Model';
import * as interfaceClassification from '@kentik/ui-shared/dictionary/interfaceClassification';
let InterfaceSettings = (_class = class InterfaceSettings extends Model {
  get defaults() {
    return {
      settings: interfaceClassification.settingsDefaults
    };
  }
  get url() {
    return '/api/ui/interfaces/rules/settings';
  }

  /**
   * Override the isNew check because this particular model doesn't return with an `id`, but instead `company_id`.
   */
  get isNew() {
    return false;
  }
  get jsonRoot() {
    return 'settings';
  }
  fetch() {
    return super.fetch();
  }
}, _applyDecoratedDescriptor(_class.prototype, "isNew", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNew"), _class.prototype), _class);
export default InterfaceSettings;